// ============================================================================
// KOREAN BIBLE PASSAGES - 개역개정
// ============================================================================
// 강한 번호가 포함된 한국어 성경 본문

export const biblePassagesKo = {
  "Changse_1": {
    book: "창세기",
    chapter: 1,
    title: "세상의 창조",
    verses: [
      { number: 1, text: "태초에 하나님이 천지를 창조하시니라", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "땅이 혼돈하고 공허하며 흑암이 깊음 위에 있고 하나님의 영은 수면 위에 운행하시니라", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "하나님이 이르시되 빛이 있으라 하시니 빛이 있었고", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "빛이 하나님이 보시기에 좋았더라 하나님이 빛과 어둠을 나누사", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "하나님이 빛을 낮이라 부르시고 어둠을 밤이라 부르시니라 저녁이 되고 아침이 되니 이는 첫째 날이니라", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "하나님이 이르시되 물 가운데에 궁창이 있어 물과 물로 나뉘라 하시고", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "하나님이 궁창을 만드사 궁창 아래의 물과 궁창 위의 물로 나뉘게 하시니 그대로 되니라", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "하나님이 궁창을 하늘이라 부르시니라 저녁이 되고 아침이 되니 이는 둘째 날이니라", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "하나님이 자기 형상 곧 하나님의 형상대로 사람을 창조하시되 남자와 여자를 창조하시고", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "하나님이 지으신 그 모든 것을 보시니 보시기에 심히 좋았더라 저녁이 되고 아침이 되니 이는 여섯째 날이니라", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Sipen_23": {
    book: "시편",
    chapter: 23,
    title: "여호와는 나의 목자",
    verses: [
      { number: 1, text: "여호와는 나의 목자시니 내게 부족함이 없으리로다", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "그가 나를 푸른 풀밭에 누이시며 쉴 만한 물 가로 인도하시는도다", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "내 영혼을 소생시키시고 자기 이름을 위하여 의의 길로 인도하시는도다", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "내가 사망의 음침한 골짜기로 다닐지라도 해를 두려워하지 않을 것은 주께서 나와 함께 하심이라 주의 지팡이와 막대기가 나를 안위하시나이다", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "주께서 내 원수의 목전에서 내게 상을 차려 주시고 기름을 내 머리에 부으셨으니 내 잔이 넘치나이다", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "내 평생에 선하심과 인자하심이 반드시 나를 따르리니 내가 여호와의 집에 영원히 살리로다", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yohane_3": {
    book: "요한복음",
    chapter: 3,
    title: "예수와 니고데모",
    verses: [
      { number: 16, text: "하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니 이는 그를 믿는 자마다 멸망하지 않고 영생을 얻게 하려 하심이라", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "하나님이 그 아들을 세상에 보내신 것은 세상을 심판하려 하심이 아니요 그로 말미암아 세상이 구원을 받게 하려 하심이라", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "그를 믿는 자는 심판을 받지 아니하는 것이요 믿지 아니하는 자는 하나님의 독생자의 이름을 믿지 아니하므로 벌써 심판을 받은 것이니라", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Billipbo_4": {
    book: "빌립보서",
    chapter: 4,
    title: "하나님의 평강",
    verses: [
      { number: 4, text: "주 안에서 항상 기뻐하라 내가 다시 말하노니 기뻐하라", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "아무 것도 염려하지 말고 다만 모든 일에 기도와 간구로, 너희 구할 것을 감사함으로 하나님께 아뢰라", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "그리하면 모든 지각에 뛰어난 하나님의 평강이 그리스도 예수 안에서 너희 마음과 생각을 지키시리라", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "내게 능력 주시는 자 안에서 내가 모든 것을 할 수 있느니라", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesKo;
